// Copyright (c) 2017 TrainHeroic LLC
// Actions for Designer Table of Contents View

import * as CalendarState from '../calendar/calendar';
import * as ProgramService from '../../../api/service/programService';

import * as ProgramTypes from '../calendar/programTypes';

export const gotoProgramDay = function(date, programType) {
    const athleteId = CalendarState.getAthleteId();
    const programId = CalendarState.getProgramId();

    const calendarId = ProgramTypes.getAthleteValue(
        programType,
        athleteId,
        programId
    );

    if (ProgramTypes.isProgram(programType)) {
        return ProgramService.gotoProgramDay(calendarId, date.week, date.day);
    }

    return ProgramService.gotoCalendarDay(
        calendarId,
        date.month,
        date.day,
        date.year,
        programType
    );
};
